import axios from 'axios';
import dayjs from 'src/utils/dayjs';

const isAwsSignedUrl = url => {
  const awsSignatureParams = ['X-Amz-Signature', 'AWSAccessKeyId', 'Signature'];
  return awsSignatureParams.some(param =>
    new RegExp(`[?&]${param}=`).test(url)
  );
};

const getFileExtensionFromUrl = url => {
  if (isAwsSignedUrl(url)) {
    return url
      .split('?')[0]
      .split('.')
      .pop();
  }
  return url.split('.').pop();
};

const getFileFromExternalLink = (
  link,
  filename = `Documento ${dayjs.tz().format('DD-MM-YYYY')}`
) => {
  axios.get(link, {
    responseType: 'blob',
    transformResponse: res => {
      try {
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(res);
        const extension = getFileExtensionFromUrl(link);
        a.download = `${filename}.${extension}`;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
      } catch (error) {
        console.log(`Opps, un error: ${error}`);
        console.error(error);
      }
    }
  });
};

export default getFileFromExternalLink;
